import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["from", "through", "button", "status", "title", "progress", "message"]

  connect() {
    const message = window.sessionStorage.getItem("mailbox-date-import-complete")
    if (message) {
      window.sessionStorage.removeItem("mailbox-date-import-complete")
      this.showStatus(message, "complete")
    }
  }

  async start(event) {
    event.preventDefault()
    if (this.running) return

    const dates = `${this.fromTarget.value}:${this.throughTarget.value}`
    if (this.dates !== dates) {
      this.dates = dates
      this.cursor = null
      this.fetched = 0
      this.created = 0
      this.updated = 0
    }

    this.running = true
    this.buttonTarget.disabled = true
    this.fromTarget.disabled = true
    this.throughTarget.disabled = true

    try {
      while (true) {
        this.showStatus(`Importing Inbox emails… ${this.fetched} fetched so far.`)
        const payload = this.cursor
          ? { cursor: this.cursor }
          : { start_date: this.fromTarget.value, end_date: this.throughTarget.value }
        const response = await fetch(this.element.action, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
          },
          credentials: "same-origin",
          body: JSON.stringify(payload)
        })
        const data = await response.json()
        if (!response.ok) throw new Error(data.error || "Mailbox import failed")

        this.fetched += data.fetched
        this.created += data.created
        this.updated += data.updated
        this.cursor = data.cursor
        if (data.complete) {
          window.sessionStorage.setItem(
            "mailbox-date-import-complete",
            `Imported ${this.fetched} Inbox emails (${this.created} new, ${this.updated} updated). You can now analyze them.`
          )
          window.location.reload()
          return
        }
      }
    } catch (error) {
      this.showStatus(`${error.message}. ${this.fetched} emails fetched so far. Select Import date range to retry.`, "error")
    } finally {
      this.running = false
      this.buttonTarget.disabled = false
      this.fromTarget.disabled = false
      this.throughTarget.disabled = false
    }
  }

  showStatus(message, state = "importing") {
    this.statusTarget.hidden = false
    this.statusTarget.dataset.state = state
    this.titleTarget.textContent = {
      importing: `${(this.fetched || 0).toLocaleString()} emails fetched · Importing Inbox`,
      complete: "Import complete — ready for AI analysis",
      error: "Import paused — retry to continue"
    }[state]
    this.messageTarget.textContent = message
    this.progressTarget.hidden = state === "error"
    if (state === "complete") {
      this.progressTarget.setAttribute("aria-valuenow", "100")
      this.progressTarget.setAttribute("aria-valuetext", "Import complete")
    } else {
      this.progressTarget.removeAttribute("aria-valuenow")
      this.progressTarget.setAttribute("aria-valuetext", `${this.fetched || 0} emails fetched; total not yet known`)
    }
  }
}
